module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/204d1ed39be62b431cebb92ee04309ca.png";